<template>
    <div class="content">
        <div class="content-view">
            <div class="action" v-if="next == 1">
                <div class="action-title">订单号查询</div>
                <div class="flex">
                    <el-input class="w500 mr20" v-model="orderNo" placeholder="请输入订单号" clearable></el-input>
                    <el-button type="primary" @click="queryOrder">查询</el-button>
                </div>
            </div>
            <div class="" v-if="next >= 2" v-show="next == 2">
                <div class="action-title">选择商品</div>
                <el-descriptions title="" class="">
                    <el-descriptions-item label="目标订单">订单号：{{ orderNo }}</el-descriptions-item>
                </el-descriptions>
                <div class="tabs-container">
                    <div class="sticky-tabs">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="控制柜配置" name="1"></el-tab-pane>
                            <el-tab-pane label="壁挂式控制器" name="2"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="scroll-content">
                        <div v-show="activeName === '1'">
                            <ControlCabinet @Cart_ControlCabinetPackage_Add="Cart_ControlCabinetPackage_Add" @searchShoppingCart="searchShoppingCart" ref="ControlCabinet"></ControlCabinet>
                        </div>
                        <div v-show="activeName === '2'">
                            <GetWallHanging @Cart_WallHanging_Add="Cart_WallHanging_Add" @searchShoppingCart="searchShoppingCart" ref="GetWallHanging"></GetWallHanging>
                        </div>
                    </div>
                </div>
                <div class="customerButtom">
                    <el-button type="primary" v-show="activeName == '1'" @click="CartControlCabinetPackageAdd()">加入配柜到购物车</el-button>
                    <el-button type="primary" v-show="activeName == '2'" @click="CartWallHangingAdd()">加入壁挂到购物车</el-button>
                    <el-button type="primary" @click="searchShoppingCart()">查看购物车</el-button>
                </div>
            </div>
            <div v-if="next == 3">
                <div class="action-title">购物车</div>
                <el-descriptions title="" class="">
                    <el-descriptions-item label="目标订单">订单号：{{ orderNo }}</el-descriptions-item>
                </el-descriptions>
                <div v-if="Twlist.length > 0">
                    <el-table :data="Twlist" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                        <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                        <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="150"></el-table-column>
                        <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip min-width="350"></el-table-column>
                        <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip></el-table-column>

                        <el-table-column prop="prop" label="数量" align="center" width="150">
                            <template v-slot="scope">
                                <div v-if="scope.row.Goods_DeliveryAmountInput == 'true'">
                                    <el-input-number v-model="scope.row.Goods_DeliveryAmount" :min="1" :max="9999999" @change="changeMethods(scope.row)"></el-input-number>
                                </div>
                                <div v-else>x {{ scope.row.Goods_DeliveryAmount }}</div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="prop" label="操作" align="center" width="100">
                            <template v-slot="scope">
                                <el-button type="danger" v-if="scope.row.DelState == 'true'" style="cursor: pointer" @click="deleteChoose(scope.row.Goods_ID)" size="mini">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="customerButtom">
                    <el-button type="primary" @click="OfflineCabinetOrdersEdit()">提交</el-button>
                    <el-button type="primary" @click="next = 2">返回</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ControlCabinet from '@/components/ControlCabinet/index.vue';
import GetWallHanging from '@/components/GetWallHanging/index.vue';
import { myMixin } from '@/utils/mixin.js';
export default {
    mixins: [myMixin],
    components: {
        ControlCabinet,
        GetWallHanging
    },

    data() {
        return {
            orderNo: '',
            next: 1,
            activeName: '1',
            Twlist: [],
            submitJson: {
                Orders_SN: '',
                orders_target: 0,
                isconfirm: 0,
                cartgoods: ''
            },
            nowCartId: ''
        };
    },
    mounted() {
        // this.searchShoppingCart();
    },

    methods: {
        queryOrder() {
            if (!this.orderNo) {
                this.$message.error('请输入订单号');
                return;
            }
            let loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi.order
                .CheckCabinetOrders({
                    Orders_SN: this.orderNo
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.next = 2;
                        this.$message.success('订单查询成功');
                        this.submitJson.Orders_SN = this.orderNo;
                    }
                })
                .finally(() => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                });
        },
        handleClick(e) {
            const r = this.activeName;
            if (r == 1) {
                // 控制柜配置
                this.$refs.ControlCabinet.GetControlCabinetProductModel();
                this.$refs.ControlCabinet.GetControlCabinetProductCanbinet();
            }
            if (r == 2) {
                this.$refs.GetWallHanging.GetModel();
            }
        },
        // 柜台加入购物车
        async Cart_ControlCabinetPackage_Add(e) {
            let dataObj = {
                ...e,
                Orders_ID: -1,
                TradeType: 0
            };
            let json = JSON.stringify(dataObj);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.Cart_ControlCabinetPackage_Add({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                this.$message.success(result.data.Resultinfo);
            }
        },
        async Cart_WallHanging_Add(e) {
            let dataObj = {
                ...e,
                Orders_ID: -1,
                TradeType: 0
            };
            let json = JSON.stringify(dataObj);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.Cart_WallHanging_Add({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode == 0) {
                this.$message.success(result.data.Resultinfo || '添加成功');
            }
        },
        CartWallHangingAdd() {
            this.$refs.GetWallHanging.Cart_WallHanging_Add();
        },
        CartControlCabinetPackageAdd() {
            this.$refs.ControlCabinet.Cart_ControlCabinetPackage_Add();
        },
        searchShoppingCart() {
            let json = JSON.stringify({
                orders_id: -1,
                member_id: 0,
                orders_type: 0
            });

            this.$newsApi.order
                .OfflineOrders_Goods_List({
                    ispreview: false,

                    Json: json
                })
                .then((res) => {
                    console.log(res);
                    if (res.data.Resultcode == 0) {
                        this.Twlist = res.data.data.Goods;
                        this.submitJson.cartgoods = res.data.Resultinfo;
                    }else{
                        this.Twlist = [];
                        this.submitJson.cartgoods = res.data.Resultinfo;
                    }
                });
            this.submitJson.Orders_SN = this.orderNo;
            this.next = 3;
        },
        deleteChoose(e) {
            this.$confirm('您确定要删除当前商品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
            })
                .then(async () => {
                    console.log(e);
                    this.nowCartId = e;
                    let result = await this.deleteShop();
                    if (result.resultcode == 0) {
                        this.$message.success(result.resultinfo);
                    }
                    this.searchShoppingCart();
                })
                .catch(() => {})
                .finally(() => {});
        },
        // 删除购物车商品
        async deleteShop() {
            let coods = this.nowCartId;
            let result = await this.$newsApi.order.officeCartGoodstmpDel({
                Orders_id: -1,
                Orders_buyerID: 0,
                Orders_Type: 0,
                TradeType: 0,
                Good_id: coods
            });
            return result;
        },
        async changeMethods(e) {
            let obj = {
                Orders_id: -1,
                Orders_buyerID: 0,
                Orders_Type: 0,
                TradeType: 0,
                Good_id: e.Goods_ID,
                buyamount: e.Goods_DeliveryAmount
            };
            let result = await this.$newsApi.order.Office_Cart_Goodstmp_Edit(obj);
            if (result.data.resultcode == 0) {
                this.searchShoppingCart();
            }
        },
        async OfflineCabinetOrdersEdit() {
            let res = await this.$newsApi.order.OfflineCabinetOrders_Edit({json: JSON.stringify(this.submitJson)});
            if (res.data.Resultcode == 0) {
                this.$message.success('提交成功');
                this.$store.dispatch('delView', this.$route);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.content-view {
    background: #fff;
    padding: 20px;
    margin-bottom: 50px;
    min-height: 80vh;
    overflow-y: auto;
}
.action-title {
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 15px;
}
.tabs-container {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
}
.sticky-tabs {
    position: sticky;
    top: -20px;
    z-index: 10;

    background: #fff;
}
.scroll-content {
    flex: 1;
    overflow-y: auto;
    padding: 20px 0;
}
.moneyRed {
    font-weight: 700;
    color: red;
}
.cartTableBottom {
    padding: 10px;
    border: 1px #dfe6ec solid;
    border-top: 0px;
}
</style>